import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  chatToggle: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#f1f1f1",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "0px",

    border: "2px solid #8C2148", // glowing border
  },

  chatPopup: {
    position: "fixed",
    bottom: "80px",
    right: "20px",
    width: "320px",
    height: "420px",
    background: "white",
    border: "1px solid #ccc",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
    overflow: "hidden",
  },

  chatHeader: {
    background: theme.palette.Primary.background,
    color: "white",
    padding: "10px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  chatBody: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
    maxHeight: "60vh",
    overflowY: "auto",
    minHeight: "75%",
  },

  chatMsg: {
    marginBottom: "10px",
    padding: "8px",
    borderRadius: "6px",
    maxWidth: "85%",
  },

  chatMsgBot: {
    alignSelf: "flex-start",
    backgroundColor: "#f1f1f1",
    color: "#333",
    borderRadius: "12px",
    padding: "10px 14px",
    maxWidth: "75%",
    fontSize: "0.95rem",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  chatMsgUser: {
    alignSelf: "flex-end",
    backgroundColor: "#685e61",
    color: "white",
    borderRadius: "12px",
    padding: "10px 14px",
    maxWidth: "75%",
    fontSize: "0.95rem",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
  },

  chatInput: {
    display: "flex",
    padding: "8px",
    borderTop: "1px solid #ddd",
  },

  chatInputInput: {
    flex: 1,
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    outline: "none",
  },

  chatInputButton: {
    marginLeft: "8px",
    padding: "8px 12px",
    background: theme.palette.Primary.background,
    border: "none",
    color: "white",
    borderRadius: "6px",
    cursor: "pointer",
  },

  glowButton: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "#f1f1f1",
    color: "white",
    padding: "15px",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: 0,
    border: "2px solid rgba(139, 33, 71, 0.8)",
    boxShadow: "0 0 0 rgba(139, 33, 71, 0.4)",
    animation: "glowPulse 2s infinite",
  },
}));

export default useStyles;
